<template>
    <div class="panel-body">
        <HeaderGeneral :vista="'Gestión de Retiros Independientes'" :ruta="'- Retiros Independientes'" :carpeta="'Proveedores'" />
        <hr class="my-4">

        <b-tabs v-model="tabActivo" class="mb-3" @input="onTabChange">
            <b-tab v-for="tab in tabs" :key="tab.estado">
                <template #title>
                    {{ tab.label }}
                    <b-badge pill :style="tab.estilo" class="ml-1">{{ conteos[tab.estado] || 0 }}</b-badge>
                </template>
            </b-tab>
        </b-tabs>

        <b-row class="mb-3" align-v="center">
            <b-col md="3">
                <b-form-select v-model="buscarCampo" :options="opcionesBusqueda" @change="onCampoChange" />
            </b-col>
            <b-col md="3">
                <b-form-input v-model="buscarValor" placeholder="Valor a buscar..." :disabled="!buscarCampo" @keyup.enter="buscar" />
            </b-col>
            <b-col md="auto">
                <b-button variant="primary" :disabled="!buscarCampo || !buscarValor.trim()" @click="buscar">
                    <b-icon icon="search" /> Buscar
                </b-button>
                <b-button variant="outline-secondary" class="ml-1" @click="limpiarBusqueda">Limpiar</b-button>
            </b-col>
            <b-col md="2">
                <b-form-select v-model="porPagina" :options="opcionesPorPagina" @change="onPorPaginaChange" />
            </b-col>
            <b-col class="text-right">
                <span class="text-muted small mr-2">{{ totalRegistros }} registro(s)</span>
                <b-button variant="outline-primary" size="sm" @click="cargarRetiros">
                    <b-icon icon="arrow-clockwise" />
                </b-button>
            </b-col>
        </b-row>

        <b-overlay :show="cargando" rounded="sm">
            <b-table :items="registros" :fields="campos" responsive striped hover show-empty :empty-text="tabActual.emptyText">
                <template #cell(paciente)="row">
                    <strong>{{ row.item.data.nombre_completo || '-' }}</strong><br>
                    <small class="text-muted">{{ tipoDocNombre(row.item.data.tipo_documento) }} {{ row.item.data.documento }}</small>
                </template>
                <template #cell(ubicacion)="row">
                    {{ row.item.data.barrio }}<br>
                    <small>{{ municipioNombre(row.item.data.municipio) }}, {{ departamentoNombre(row.item.data.departamento) }}</small>
                </template>
                <template #cell(equipos)="row">
                    <div v-if="row.item.data.elementos_retiro && row.item.data.elementos_retiro.length">
                        <b-badge v-for="id in row.item.data.elementos_retiro" :key="id" variant="light" class="mr-1 mb-1 border text-dark">
                            {{ elementoNombre(id) }}
                        </b-badge>
                    </div>
                    <span v-else class="text-muted">-</span>
                </template>
                <template #cell(estado)="row">
                    <b-badge :style="estiloEstado(row.item.data.estado)">{{ nombreEstado(row.item.data.estado) }}</b-badge>
                </template>
                <template #cell(acciones)="row">
                    <b-button variant="outline-info" size="sm" class="mr-1" @click="verDetalle(row.item)"><b-icon icon="eye" /></b-button>
                    <template v-if="row.item.data.estado == 3">
                        <b-button variant="outline-primary" size="sm" class="mr-1" @click="abrirIniciarProceso(row.item)">
                            <b-icon icon="play-circle" /> Iniciar
                        </b-button>
                        <b-button variant="outline-danger" size="sm" @click="abrirNoRealizar(row.item)">
                            <b-icon icon="x-circle" /> No realizar
                        </b-button>
                    </template>
                    <template v-if="row.item.data.estado == 14">
                        <b-button variant="outline-success" size="sm" class="mr-1" @click="abrirCompletar(row.item)">
                            <b-icon icon="check-circle" /> Completar
                        </b-button>
                        <b-button variant="outline-danger" size="sm" @click="abrirNoRealizar(row.item)">
                            <b-icon icon="x-circle" /> No realizado
                        </b-button>
                    </template>
                </template>
            </b-table>

            <b-pagination v-model="paginaActual" :total-rows="totalRegistros" :per-page="porPagina" align="center" @change="onPaginaChange" />
        </b-overlay>

        <!-- ── Modal Detalle ── -->
        <b-modal v-model="modalDetalle" :title="'Detalle Retiro N° ' + (seleccionado ? seleccionado.data.id : '')" size="lg" ok-only ok-title="Cerrar" header-bg-variant="light">
            <div v-if="seleccionado">
                <b-row class="mb-3">
                    <b-col md="6">
                        <h6 class="font-weight-bold border-bottom pb-1 mb-2">Paciente</h6>
                        <p class="mb-1"><span class="text-muted">Nombre:</span> <strong>{{ seleccionado.data.nombre_completo || '-' }}</strong></p>
                        <p class="mb-1"><span class="text-muted">Documento:</span> {{ tipoDocNombre(seleccionado.data.tipo_documento) }} {{ seleccionado.data.documento }}</p>
                        <p class="mb-1"><span class="text-muted">Teléfono:</span> {{ seleccionado.data.telefono_1 }}</p>
                        <p class="mb-1"><span class="text-muted">Contacto:</span> {{ seleccionado.data.nombre_contacto || '-' }}</p>
                    </b-col>
                    <b-col md="6">
                        <h6 class="font-weight-bold border-bottom pb-1 mb-2">Ubicación del Retiro</h6>
                        <p class="mb-1"><span class="text-muted">Barrio:</span> {{ seleccionado.data.barrio || '-' }}</p>
                        <p class="mb-1"><span class="text-muted">Municipio:</span> {{ municipioNombre(seleccionado.data.municipio) }}</p>
                        <p class="mb-1"><span class="text-muted">Departamento:</span> {{ departamentoNombre(seleccionado.data.departamento) }}</p>
                    </b-col>
                </b-row>
                <h6 class="font-weight-bold border-bottom pb-1 mb-2">Equipos a Retirar</h6>
                <div class="mb-3">
                    <b-badge v-for="id in (seleccionado.data.elementos_retiro || [])" :key="id" variant="light" class="mr-2 mb-1 p-2 border text-dark" style="font-size:0.85rem">
                        {{ elementoNombre(id) }}
                    </b-badge>
                    <span v-if="!seleccionado.data.elementos_retiro || !seleccionado.data.elementos_retiro.length" class="text-muted">Sin equipos</span>
                </div>
                <h6 class="font-weight-bold border-bottom pb-1 mb-2">Gestión</h6>
                <b-table-simple small bordered class="mb-3">
                    <b-tbody>
                        <b-tr><b-td class="text-muted" style="width:40%">Estado</b-td><b-td><b-badge :style="estiloEstado(seleccionado.data.estado)">{{ nombreEstado(seleccionado.data.estado) }}</b-badge></b-td></b-tr>
                        <b-tr><b-td class="text-muted">Fecha asignación</b-td><b-td>{{ formatFecha(seleccionado.data.fecha_asignacion) || '-' }}</b-td></b-tr>
                        <b-tr><b-td class="text-muted">Inicio proceso</b-td><b-td>{{ formatFecha(seleccionado.data.fecha_proceso_retiro) || '-' }}</b-td></b-tr>
                        <b-tr><b-td class="text-muted">Retiro efectivo</b-td><b-td>{{ formatFecha(seleccionado.data.fecha_retiro_efectivo) || '-' }}</b-td></b-tr>
                        <b-tr v-if="seleccionado.data.motivo_no_retiro"><b-td class="text-muted">Motivo no retiro</b-td><b-td class="text-danger">{{ seleccionado.data.motivo_no_retiro }}</b-td></b-tr>
                        <b-tr v-if="seleccionado.data.observaciones_retiro"><b-td class="text-muted">Observaciones</b-td><b-td>{{ seleccionado.data.observaciones_retiro }}</b-td></b-tr>
                    </b-tbody>
                </b-table-simple>
                <h6 class="font-weight-bold border-bottom pb-1 mb-2">Documentos adjuntos</h6>
                <AdjuntosRetiro :id-retiro="seleccionado.data.id" :solo-lectura="true" />

                <h6 class="font-weight-bold border-bottom pb-1 mb-2 mt-3">Historial de cambios</h6>
                <HistorialRetiro :id-retiro="Number(seleccionado.data.id)" />
            </div>
        </b-modal>

        <!-- ── Modal Iniciar proceso ── -->
        <b-modal v-model="modalIniciar" title="Iniciar Proceso de Retiro" @ok="confirmarIniciarProceso" ok-title="Confirmar inicio" cancel-title="Cancelar" :ok-disabled="procesando">
            <b-overlay :show="procesando">
                <div v-if="gestionando">
                    <b-list-group flush class="mb-3">
                        <b-list-group-item><strong>N° Solicitud:</strong> {{ gestionando.data.id }}</b-list-group-item>
                        <b-list-group-item><strong>Paciente:</strong> {{ gestionando.data.nombre_completo || '-' }}</b-list-group-item>
                        <b-list-group-item><strong>Dirección:</strong> {{ gestionando.data.barrio }}, {{ municipioNombre(gestionando.data.municipio) }}</b-list-group-item>
                        <b-list-group-item><strong>Equipos:</strong> {{ (gestionando.data.elementos_retiro || []).map(id => elementoNombre(id)).join(', ') }}</b-list-group-item>
                    </b-list-group>
                    <b-form-group label="Observaciones de inicio">
                        <b-form-textarea v-model="gestionForm.observaciones_retiro" rows="3" />
                    </b-form-group>
                    <b-form-group label="Documentos adjuntos (opcional)">
                        <AdjuntosRetiro ref="adjuntosIniciar" :id-retiro="null" />
                    </b-form-group>
                </div>
            </b-overlay>
        </b-modal>

        <!-- ── Modal Completar ── -->
        <b-modal v-model="modalCompletar" title="Confirmar Retiro Realizado" @ok="confirmarCompletar" ok-title="Confirmar retiro" cancel-title="Cancelar" :ok-disabled="procesando">
            <b-overlay :show="procesando">
                <div v-if="gestionando">
                    <b-list-group flush class="mb-3">
                        <b-list-group-item><strong>N° Solicitud:</strong> {{ gestionando.data.id }}</b-list-group-item>
                        <b-list-group-item><strong>Paciente:</strong> {{ gestionando.data.nombre_completo || '-' }}</b-list-group-item>
                        <b-list-group-item><strong>Equipos:</strong> {{ (gestionando.data.elementos_retiro || []).map(id => elementoNombre(id)).join(', ') }}</b-list-group-item>
                    </b-list-group>
                    <b-form-group label="Fecha y hora de retiro efectivo *">
                        <b-form-input v-model="gestionForm.fecha_retiro_efectivo" type="datetime-local" />
                    </b-form-group>
                    <b-form-group label="Observaciones del retiro">
                        <b-form-textarea v-model="gestionForm.observaciones_retiro" rows="3" />
                    </b-form-group>
                    <b-form-group label="Soporte del retiro (remisión, foto, etc.) *">
                        <small class="text-muted d-block mb-1">Obligatorio — adjunte al menos un documento de soporte.</small>
                        <AdjuntosRetiro ref="adjuntosCompletar" :id-retiro="null" />
                    </b-form-group>
                </div>
            </b-overlay>
        </b-modal>

        <!-- ── Modal No realizar ── -->
        <b-modal v-model="modalNoRealizar" title="Reportar Retiro No Realizado" @ok="confirmarNoRealizar" ok-title="Reportar" cancel-title="Cancelar" ok-variant="danger" :ok-disabled="!gestionForm.motivo_no_retiro || procesando">
            <b-overlay :show="procesando">
                <div v-if="gestionando">
                    <b-alert show variant="warning" class="text-dark"><b-icon icon="exclamation-triangle" /> El prestador será notificado para reasignar.</b-alert>
                    <b-list-group flush class="mb-3">
                        <b-list-group-item><strong>N° Solicitud:</strong> {{ gestionando.data.id }}</b-list-group-item>
                        <b-list-group-item><strong>Paciente:</strong> {{ gestionando.data.nombre_completo || '-' }}</b-list-group-item>
                    </b-list-group>
                    <b-form-group label="Motivo del no retiro *">
                        <b-form-select v-model="gestionForm.motivo_no_retiro" :options="motivosNoRetiro" />
                    </b-form-group>
                    <b-form-group label="Observaciones">
                        <b-form-textarea v-model="gestionForm.observaciones_retiro" rows="3" />
                    </b-form-group>
                    <b-form-group label="Evidencia del intento (opcional)">
                        <AdjuntosRetiro ref="adjuntosNoRealizar" :id-retiro="null" />
                    </b-form-group>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import AdjuntosRetiro from "../../components/AdjuntosRetiro.vue";
import HistorialRetiro from "../../components/HistorialRetiro.vue";
import { OPCIONES_BUSQUEDA, buildFiltrosBusqueda } from "../Retiros/retiroBuscadorMixin.js";

const retiroRepo = RepositoryFactory.get("retiro");
const config     = RepositoryFactory.get("config");

const ESTADOS = {
    1:  { nombre: 'Pendiente asignación', style: { backgroundColor: '#f0ad4e', color: '#212529' } },
    3:  { nombre: 'Asignado',             style: { backgroundColor: '#f0ad4e', color: '#212529' } },
    14: { nombre: 'En proceso',           style: { backgroundColor: '#6f42c1', color: '#ffffff' } },
    13: { nombre: 'Retirado',             style: { backgroundColor: '#198754', color: '#ffffff' } },
    15: { nombre: 'No realizado',         style: { backgroundColor: '#dc3545', color: '#ffffff' } },
};

const TABS = [
    { estado: 3,  label: 'Asignados',     emptyText: 'No tiene retiros asignados pendientes.',    estilo: { backgroundColor:'#f0ad4e', color:'#212529' } },
    { estado: 14, label: 'En proceso',    emptyText: 'No tiene retiros en proceso.',              estilo: { backgroundColor:'#6f42c1', color:'#ffffff' } },
    { estado: 13, label: 'Completados',   emptyText: 'No tiene retiros completados.',             estilo: { backgroundColor:'#198754', color:'#ffffff' } },
    { estado: 15, label: 'No realizados', emptyText: 'No tiene retiros reportados como no realizados.', estilo: { backgroundColor:'#dc3545', color:'#ffffff' } },
];

export default {
    components: { HeaderGeneral, AdjuntosRetiro, HistorialRetiro },
    data() {
        return {
            cargando: false, procesando: false,
            registros: [], totalRegistros: 0,
            paginaActual: 1, porPagina: 15,
            buscarCampo: null, buscarValor: '',
            opcionesBusqueda: OPCIONES_BUSQUEDA,
            tabActivo: 0, tabs: TABS, conteos: {},
            modalDetalle: false, modalIniciar: false, modalCompletar: false, modalNoRealizar: false,
            seleccionado: null, gestionando: null,
            gestionForm: { observaciones_retiro: '', fecha_retiro_efectivo: '', motivo_no_retiro: null },
            tiposDocMap: {}, elementosMap: {}, departamentosMap: {}, municipiosMap: {},
            proveedorFiltro: [],
            motivosNoRetiro: [
                { value: null, text: 'Seleccionar motivo...' },
                { value: 'Paciente no se encontraba',        text: 'Paciente no se encontraba en la dirección' },
                { value: 'Acceso denegado',                  text: 'Acceso denegado a la dirección' },
                { value: 'Equipo no disponible para retiro', text: 'Equipo no disponible para retiro' },
                { value: 'Dificultad de acceso por vías',    text: 'Dificultad de acceso por vías' },
                { value: 'Problema con el vehículo',         text: 'Problema con el vehículo' },
                { value: 'Otro',                             text: 'Otro motivo' },
            ],
            opcionesPorPagina: [
                { value: 10, text: '10 por página' }, { value: 15, text: '15 por página' },
                { value: 25, text: '25 por página' }, { value: 50, text: '50 por página' },
            ],
            campos: [
                { key: 'data.id',              label: 'N° Sol.', sortable: true },
                { key: 'paciente',             label: 'Paciente' },
                { key: 'ubicacion',            label: 'Ubicación' },
                { key: 'equipos',              label: 'Equipos' },
                { key: 'estado',               label: 'Estado' },
                { key: 'data.fecha_asignacion',label: 'Asignado', formatter: (v) => this.formatFecha(v) },
                { key: 'acciones',             label: 'Acciones' },
            ],
        };
    },
    computed: {
        tabActual() { return TABS[this.tabActivo] || TABS[0]; },
    },
    async mounted() {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.id_proveedor) {
            this.proveedorFiltro = [{ id_proveedor: { equals: String(user.id_proveedor) } }];
        }
        await this.cargarListados();
        await this.cargarRetiros();
        this.cargarConteos();
    },
    methods: {
        async cargarRetiros() {
            this.cargando = true;
            try {
                const filtros = [
                    { estado: { equals: String(this.tabActual.estado) } },
                    ...this.proveedorFiltro,
                    ...buildFiltrosBusqueda(this.buscarCampo, this.buscarValor),
                ];
                const resp = await retiroRepo.consultarRetirosIndependientes({
                    page: this.paginaActual, size: this.porPagina, filtros,
                });
                this.registros      = resp.rows;
                this.totalRegistros = resp.count;
                this.$set(this.conteos, this.tabActual.estado, resp.count);
            } catch (e) { this.registros = []; this.totalRegistros = 0; }
            finally { this.cargando = false; }
        },
        async cargarConteos() {
            try {
                const datos = await retiroRepo.contarRetirosIndependientesPorEstado(this.proveedorFiltro);
                const nuevos = {};
                TABS.forEach(t => { nuevos[t.estado] = datos[String(t.estado)] || 0; });
                this.conteos = nuevos;
            } catch (e) { /* mantener conteos anteriores */ }
        },
        buscar() {
            if (!this.buscarCampo || !this.buscarValor.trim()) return;
            this.paginaActual = 1;
            this.cargarRetiros();
        },
        limpiarBusqueda() {
            this.buscarCampo = null;
            this.buscarValor = '';
            this.paginaActual = 1;
            this.cargarRetiros();
        },
        onCampoChange()    { this.buscarValor = ''; },
        onTabChange()      { this.paginaActual = 1; this.cargarRetiros(); },
        onPaginaChange(p)  { this.paginaActual = p; this.cargarRetiros(); },
        onPorPaginaChange(){ this.paginaActual = 1; this.cargarRetiros(); },
        async cargarListados() {
            try {
                const response = await config.listasDesplegables({ nombre_entidad: 'listados' });

                const tiposDoc = response.find(i => i.data.nombre_lista === 'Tipos_documento');
                if (tiposDoc) {
                    const map = {};
                    tiposDoc.data.rows.forEach(r => { map[r.id] = r.name; });
                    this.tiposDocMap = map;
                }

                const elementos = response.find(i => i.data.nombre_lista === 'elementos');
                if (elementos) {
                    const map = {};
                    elementos.data.rows.forEach(r => { map[r.id] = r.name; });
                    this.elementosMap = map;
                }

                const divipola = response.find(i => i.data.nombre_lista === 'divipola_colombia');
                if (divipola) {
                    const depMap = {}, munMap = {};
                    divipola.data.rows.forEach(r => {
                        depMap[r.codigo_departamento] = r.nombre_departamento;
                        munMap[r.codigo_municipio]    = r.nombre_municipio;
                    });
                    this.departamentosMap = depMap;
                    this.municipiosMap    = munMap;
                }
            } catch (e) { /* silencioso */ }
        },
        abrirIniciarProceso(item) { this.gestionando = item; this.gestionForm = { observaciones_retiro:'', fecha_retiro_efectivo:'', motivo_no_retiro: null }; this.modalIniciar = true; },
        abrirCompletar(item) {
            this.gestionando = item;
            const ahora = new Date(); ahora.setMinutes(ahora.getMinutes() - ahora.getTimezoneOffset());
            this.gestionForm = { observaciones_retiro:'', fecha_retiro_efectivo: ahora.toISOString().slice(0,16), motivo_no_retiro: null };
            this.modalCompletar = true;
        },
        abrirNoRealizar(item) { this.gestionando = item; this.gestionForm = { observaciones_retiro:'', fecha_retiro_efectivo:'', motivo_no_retiro: null }; this.modalNoRealizar = true; },
        async confirmarIniciarProceso(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.procesando = true;
            try {
                const id = this.gestionando.data.id;
                await retiroRepo.actualizarEstadoRetiro({ id_metadata: id, estado: 14, fecha_proceso_retiro: new Date().toISOString(), observaciones_retiro: this.gestionForm.observaciones_retiro });
                if (this.$refs.adjuntosIniciar?.hayArchivos()) await this.$refs.adjuntosIniciar.subirArchivos(id);
                this.modalIniciar = false; await this.cargarRetiros(); this.cargarConteos();
                this.$bvToast.toast('Proceso de retiro iniciado.', { title: 'Proceso iniciado', variant: 'primary', solid: true });
            } catch (e) { this.$bvToast.toast('Error al actualizar.', { title: 'Error', variant: 'danger', solid: true }); }
            finally { this.procesando = false; }
        },
        async confirmarCompletar(bvModalEvent) {
            bvModalEvent.preventDefault();
            if (!this.gestionForm.fecha_retiro_efectivo) { this.$bvToast.toast('La fecha es requerida.', { title: 'Campo requerido', variant: 'warning', solid: true }); return; }
            if (!this.$refs.adjuntosCompletar?.hayArchivos()) { this.$bvToast.toast('Debe adjuntar al menos un soporte del retiro.', { title: 'Campo requerido', variant: 'warning', solid: true }); return; }
            this.procesando = true;
            try {
                const id = this.gestionando.data.id;
                await retiroRepo.actualizarEstadoRetiro({ id_metadata: id, estado: 13, fecha_retiro_efectivo: new Date(this.gestionForm.fecha_retiro_efectivo).toISOString(), observaciones_retiro: this.gestionForm.observaciones_retiro });
                if (this.$refs.adjuntosCompletar?.hayArchivos()) await this.$refs.adjuntosCompletar.subirArchivos(id);
                this.modalCompletar = false; await this.cargarRetiros(); this.cargarConteos();
                this.$bvToast.toast('Retiro completado exitosamente.', { title: 'Retirado', variant: 'success', solid: true });
            } catch (e) { this.$bvToast.toast('Error al actualizar.', { title: 'Error', variant: 'danger', solid: true }); }
            finally { this.procesando = false; }
        },
        async confirmarNoRealizar(bvModalEvent) {
            bvModalEvent.preventDefault();
            if (!this.gestionForm.motivo_no_retiro) return;
            this.procesando = true;
            try {
                const id = this.gestionando.data.id;
                await retiroRepo.actualizarEstadoRetiro({ id_metadata: id, estado: 15, fecha_retiro_fallido: new Date().toISOString(), motivo_no_retiro: this.gestionForm.motivo_no_retiro, observaciones_retiro: this.gestionForm.observaciones_retiro });
                if (this.$refs.adjuntosNoRealizar?.hayArchivos()) await this.$refs.adjuntosNoRealizar.subirArchivos(id);
                this.modalNoRealizar = false; await this.cargarRetiros(); this.cargarConteos();
                this.$bvToast.toast('Retiro reportado como no realizado. El prestador será notificado.', { title: 'Notificado', variant: 'warning', solid: true });
            } catch (e) { this.$bvToast.toast('Error al actualizar.', { title: 'Error', variant: 'danger', solid: true }); }
            finally { this.procesando = false; }
        },
        verDetalle(item) { this.seleccionado = item; this.modalDetalle = true; },
        tipoDocNombre(id)          { return this.tiposDocMap[id]        || id || ''; },
        elementoNombre(id)         { return this.elementosMap[id]       || `Equipo ${id}`; },
        departamentoNombre(codigo) { return this.departamentosMap[codigo] || codigo || '-'; },
        municipioNombre(codigo)    { return this.municipiosMap[codigo]    || codigo || '-'; },
        nombreEstado(e)            { return ESTADOS[e]?.nombre || `Estado ${e}`; },
        estiloEstado(e)            { return ESTADOS[e]?.style  || { backgroundColor: '#6c757d', color: '#fff' }; },
        formatFecha(f) {
            if (!f) return '-';
            return new Date(f).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        },
    },
};
</script>
